var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "runs-box" }, [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm._f("trans")("Variations"))),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "badge badge-pro",
          on: { click: _vm.handleProOrChange },
        },
        [_vm._v(_vm._s(_vm._f("trans")("PRO")))]
      ),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("p", [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm._f("trans")(
                "You can change how much the resulting image should change."
              )
            ) +
            "\n    "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "runs-container" },
      _vm._l(_vm.runs, function (run) {
        return _c(
          "div",
          {
            staticClass: "runs-btn",
            class: {
              active: _vm.currentRun.name === run.name,
              disabled:
                !_vm.isProAndAboveUser && _vm.currentRun.name !== run.name,
            },
            on: {
              click: function ($event) {
                return _vm.handleProOrChange(run.name)
              },
            },
          },
          [
            _vm._v("\n      " + _vm._s(run.name) + "\n      "),
            _c(
              "div",
              {
                staticClass: "checkmark-box",
                class: { active: _vm.currentRun.name === run.name },
              },
              [_c("i", { staticClass: "fa fa-check" })]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }